@import url("../promotion-card/promotion-card.css");

.item {
    text-decoration: none;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding: var(--spacing-small);
    border: 1px solid var(--color-border);
    border-radius: var(--border-small);
    gap: 0.5rem;
    box-shadow: var(--shadow-inline);
}

.font {
    font-family: var(--font-family);
    font-size: var(--font-size-body);
}
